import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import React from "react";

import Icon from "@/components/atoms/media/Icon";
import { IconEnum } from "@/enums";
import { type CommonProps } from "@/types";

import styles from "./ListItem.module.css";

interface ListItemProps
  extends Partial<CommonProps & React.DOMAttributes<HTMLLIElement>> {
  children: React.ReactNode;
  icon?: IconDefinition | IconEnum;
  iconNoPadding?: boolean;
}

function ListItem(props: ListItemProps) {
  const {
    className,
    icon,
    color,
    iconColor,
    iconNoPadding = true,
    ...rest
  } = props;
  const classes = clsx(styles.listitem, color && styles[color], className);

  return (
    <li className={classes} {...rest}>
      {icon ? (
        <Icon name={icon} noPadding={iconNoPadding} color={iconColor} />
      ) : null}
      {props.children}
    </li>
  );
}

export default ListItem;
export { ListItem, type ListItemProps };
